export default __webpack_public_path__ + "static/media/repair-1.d82d47f2.jpg";